export default __webpack_public_path__ + "static/media/higher_primary_logo_centered.e174c129.svg";